<template>
  <section class="content">
    <Card>
      <template #content>
        <form>
          <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12 p-md-3">
              <label>Employee</label>
              <Dropdown v-model="employeeId" optionLabel="name" placeholder="Select One"
                        :filter="true"
                        :options="employeeList"
                        @change="findSalaryPostingList"
                        :showClear="true" id="account"/>
            </div>
            <div class="p-field p-col-12 p-md-2">
              <label>Month</label>
              <Dropdown v-model="month" optionLabel="key" placeholder="Select One"
                        :filter="true"
                        :options="monthList"
                        :showClear="true" id="account"/>
            </div>
            <div class="p-field p-col-12 p-md-2">
              <label>Year</label>
              <Dropdown v-model="year" optionLabel="key" placeholder="Select One"
                        :filter="true"
                        :options="yearList"
                        :showClear="true" id="account"/>
            </div>
            <div class="p-field p-col-12 p-md-1">
              <Button class="p-button-raised p-button-secondary p-mt-5"
                      @click.prevent="resetBtn" label="Reset"/>
            </div>
          </div>

          <DataTable
            :value="salaryList"
            editMode="cell"
            class="p-datatable-responsive-demo p-datatable-gridlines editable-cells-table"
          >
            <ColumnGroup type="header">
              <Row>
                <Column header="S.N" :rowspan="3"/>
                <Column header="Emp. Name" :rowspan="4"/>
                <Column header="Attendance" :rowspan="5"/>
              </Row>
              <Row>
                <Column header="Addition(+)" :colspan="hrEarningSalaryPostingList.length"
                        v-if="hrEarningSalaryPostingList.length > 0" />
                <Column header="Subtraction(-)" :colspan="hrDeductionSalaryPostingList.length"
                        v-if="hrDeductionSalaryPostingList.length > 0" />
                <Column header="Total Payable" :rowspan="6"
                        v-if="hrDeductionSalaryPostingList.length>0 || hrEarningSalaryPostingList.length > 0"/>
              </Row>
              <Row>
                <Column v-for="col of hrEarningSalaryPostingList" :header="col.payHeadName"
                        :key="col.payHeadId"/>
                <Column v-for="col of hrDeductionSalaryPostingList" :header="col.payHeadName"
                        :key="col.payHeadId"></Column>
              </Row>
            </ColumnGroup>

            <Column field="SN" bodyStyle="width: 4em;height: 4em">
              <template #body="slotProps">
                {{ slotProps.index + 1 }}
              </template>
            </Column>
            <Column bodyStyle="width: 20em;height: 4em">
              <template #body="slotProps">
                {{ slotProps.data.employee.name }}
              </template>
            </Column>
            <Column field="attendance" bodyStyle="width: 10em;height: 4em">
              <template #body="slotProps">
                <InputText v-model="slotProps.data[slotProps.column.field]"/>
              </template>
            </Column>
            <Column v-for="(col,index) of hrEarningSalaryPostingList" :key="col.payHeadId"
                    :field="col.amount.toString()"
                    bodyStyle="width: 10em;height: 4em">
              <template #body="slotProps">
                <input type="number" :value="slotProps.data.employeeAdditionSalaryDetailsDTOList[index].amount" disabled
                       class="p-inputtext p-component p-filled"
                       v-if="hrEarningSalaryPostingList.length > 0"/>
              </template>
            </Column>
            <Column bodyStyle="width: 10em;height: 4em" v-for="(col,index) of hrDeductionSalaryPostingList"
                    :key="col.payHeadId" :field="col.amount.toString()">
              <template #body="slotProps">
                <input type="number" :value="slotProps.data.employeeDeductionSalaryDetailsDTOList[index].amount" disabled
                       class="p-inputtext p-component p-filled"
                       v-if="hrDeductionSalaryPostingList.length > 0"/>
              </template>
            </Column>
            <Column field="totalPaying" bodyStyle="width: 10em;height: 5em"
                    v-if="hrDeductionSalaryPostingList.length>0 || hrEarningSalaryPostingList.length > 0">
              <template #body="slotProps">
                <input type="number" :value="slotProps.data.totalPaying" disabled
                       class="p-inputtext p-component p-filled"/>
              </template>
            </Column>
          </DataTable>
          <div class="p-field p-col-12 p-md-2">
            <Button class="p-button-raised p-button-success p-mt-5"
                    @click.prevent="saveSalaryEntry" label="Post Salary"/>
          </div>
        </form>
      </template>
    </Card>
  </section>
</template>

<script>
import Button from 'primevue/button'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import ColumnGroup from 'primevue/columngroup'
import Row from 'primevue/row'
import InputText from 'primevue/inputtext'
import Card from 'primevue/card'
import Dropdown from 'primevue/dropdown'
import InputNumber from 'primevue/inputnumber'

export default {
  name: 'SalaryEntry',
  props: ['SalaryEntry'],
  data() {
    return {
      openSalesEntry: false,
      totalPaying: 0,
      totalEarningAmt: 0,
      totalDeductionAmt: 0,
      salaryList: [],
      salaryPaidId: 0,
      month: null,
      monthList: [{key: 'बैशाख', value: 1}, {key: 'जेठ', value: 2}, {key: 'अषाढ', value: 3}, {
        key: 'श्रावण ',
        value: 4
      },
        {key: 'भाद्र', value: 5}, {key: 'आश्विन', value: 6}, {key: 'कार्तिक', value: 7}, {
          key: 'मङ्सिर',
          value: 8
        },
        {key: 'पौष', value: 9}, {key: 'माघ', value: 10}, {key: 'फाल्गुन', value: 11}, {
          key: 'चैत्र',
          value: 12
        }],
      year: null,
      yearList: [{key: '2078', value: 2078}],
      employeeId: null,
      hrEarningSalaryPostingList: [],
      hrDeductionSalaryPostingList: []
    }
  },
  computed: {
    employeeList() {
      return this.$store.state.hr.employeeList
    }
  },
  mounted() {
    this.findAllEmpSalaryPostingList()
    this.findEmployeeList()
  },
  methods: {
    async findSalaryPostingList() {
      let resp = ''
      try {
        resp = await this.$store.dispatch('loadHrMasterSalaryPostingList', this.employeeId.id)
      } catch (e) {
        this.$toast.add({
          severity: 'warn',
          summary: '',
          detail: 'Server threw some error. Please contact admin.',
          life: 3000
        })
        return
      }
      // let resp = await this.$store.dispatch('loadHrMasterSalaryPostingList', this.employeeId.id)
      this.salaryList = resp.data.data
      this.reset()
      this.findHrEarningSalaryPostingList()
      this.findHrDeductionSalaryPostingList()
      this.totalPayableAmount()
    },
    async findAllEmpSalaryPostingList() {
      let resp = ''
      try {
        resp = await this.$store.dispatch('loadAllEmployeeHrMasterSalaryPostingList')
      } catch (e) {
        this.$toast.add({
          severity: 'warn',
          summary: '',
          detail: 'Server threw some error. Please contact admin.',
          life: 3000
        })
        return
      }
      // let resp = await this.$store.dispatch('loadHrMasterSalaryPostingList', this.employeeId.id)
      this.salaryList = resp.data.data
      this.reset()
      this.findHrEarningSalaryPostingList()
      this.findHrDeductionSalaryPostingList()
      // this.totalPayableAmount()
    },
    async findEmployeeList() {
      try {
        await this.$store.dispatch('loadEmployeeList')
      } catch (e) {
        this.$toast.add({severity: 'warn', summary: '', detail: 'Employee Name cannot be empty!', life: 3000})
        return
      }
    },
    findHrEarningSalaryPostingList() {
      for (let i = 0; i < this.salaryList.length; i++) {
        if (this.salaryList[i].employeeAdditionSalaryDetailsDTOList.length > 0) {
          this.hrEarningSalaryPostingList = this.salaryList[i].employeeAdditionSalaryDetailsDTOList
        }
      }
    },
    totalPayableAmount() {
      // // debugger
      // eslint-disable-next-line no-unused-vars
      let totalEarningAmt = 0
      // eslint-disable-next-line no-unused-vars
      let totalDeductionAmt = 0
      // eslint-disable-next-line no-unused-vars
      for (let i = 0; i < this.hrEarningSalaryPostingList.length; i++) {
        let basicSalary = 0
        totalEarningAmt += parseFloat(this.hrEarningSalaryPostingList[i].amount)
        if (this.hrEarningSalaryPostingList[i].computeOnId !== 0) {
          basicSalary = this.hrEarningSalaryPostingList[i].amount
        }
        for (let i = 0; i < this.hrDeductionSalaryPostingList.length; i++) {
          if (this.hrDeductionSalaryPostingList[i].amountType === 'Flat') {
            totalDeductionAmt += parseFloat(this.hrDeductionSalaryPostingList[i].amount)
          } else if (this.hrDeductionSalaryPostingList[i].amountType === 'Percentage') {
            totalDeductionAmt += parseFloat(this.hrDeductionSalaryPostingList[i].amount / 100 * basicSalary)
          }
        }
      }
      this.totalPaying = parseFloat(totalEarningAmt - totalDeductionAmt)
    },
    findHrDeductionSalaryPostingList() {
      for (let i = 0; i < this.salaryList.length; i++) {
        if (this.salaryList[i].employeeDeductionSalaryDetailsDTOList.length > 0) {
          this.hrDeductionSalaryPostingList = this.salaryList[i].employeeDeductionSalaryDetailsDTOList
        }
      }
    },
    async saveSalaryEntry() {
      if (this.month === undefined || this.month === null) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please Select Month!', life: 10000})
        return
      }
      if (this.year === undefined || this.year === null) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please Select Year!', life: 10000})
        return
      }
      if (this.salaryList === null || this.salaryList.length === 0) {
        this.$toast.add({severity: 'error', summary: '', detail: 'No Employee Found For Posting Salary!', life: 10000})
        return
      }
      let SalaryEntry = {
        // employee: this.employeeId,
        month: this.month.value,
        year: this.year.value,
        // id: this.salaryPaidId,
        // employeeAdditionSalaryDetailsDTOList: this.hrEarningSalaryPostingList,
        // employeeDeductionSalaryDetailsDTOList: this.hrDeductionSalaryPostingList,
        // totalPaying: this.totalPaying
        hrSalaryPostingDTOList: this.salaryList
      }
      let response = ''
      if (this.SalaryEntry === undefined) {
        this.loading = true
        response = await this.$store.dispatch('addSalaryPosting', SalaryEntry)
        this.loading = false
      } else {
        this.loading = true
        response = await this.$store.dispatch('addSalaryPosting', SalaryEntry)
        this.loading = false
        this.$router.back()
      }
      if (response.data.status === 'SUCCESS') {
        this.$toast.add({severity: 'success', summary: '', detail: response.data.message, life: 10000})
        this.reset()
        this.saved = true
        this.salaryPaidId = response.data.data.id
      } else {
        this.$toast.add({severity: 'error', summary: '', detail: response.data.message, life: 10000})
      }
    },
    reset() {
      this.hrEarningSalaryPostingList = []
      this.hrDeductionSalaryPostingList = []
      // this.salaryList = []
    },
    resetBtn() {
      this.employeeId = null
      this.salaryList = []
      this.month = null
      this.year = null
      this.hrEarningSalaryPostingList = []
      this.hrDeductionSalaryPostingList = []
    }
  },
  components: {
    Button,
    DataTable,
    Column,
    ColumnGroup,
    Row,
    InputText,
    Card,
    Dropdown,
    InputNumber
  }
}
</script>

<style scoped>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// SalaryEntry.vue?ff43f2ec